import React from 'react';

const NotFound = () => {
    return (
        <div>
            <div className='w-full'>
            <img className='mx-auto my-10' src="https://c.tenor.com/IHdlTRsmcS4AAAAC/404.gif" alt="" />
            </div>
        </div>
    );
};

export default NotFound;